import { createTutorial } from './createTutorial'
import type { TutorialStep } from './createTutorial'

const FACTURATION_KEY = 'tutorial_facturation_seen'

const FACTURATION_STEPS: TutorialStep[] = [
  {
    id: 'fact-welcome',
    type: 'fullscreen',
    title: 'Tutoriel\nFacturation',
    description: 'Découvrez comment générer, signer et envoyer vos factures facilement depuis libheros PRO.',
    showSkip: true,
  },
  {
    id: 'fact-profile-facture',
    type: 'spotlight',
    target: '[data-tutorial="profile-facture"]',
    tab: '/tabs/profile',
    title: 'Accès aux factures',
    description: 'Depuis votre profil, cliquez sur "Facture" pour accéder à toutes vos factures et en créer de nouvelles.',
    tooltipPosition: 'top',
    scrollTo: true,
  },
  {
    id: 'demo-invoice-list',
    type: 'page',
    tab: '/tutorial/invoice',
    title: 'Liste de vos factures',
    description: 'Retrouvez toutes vos factures : à générer et vos anciennes factures finalisées.',
  },
  {
    id: 'demo-invoice-detail',
    type: 'page',
    tab: '/tutorial/invoice/detail',
    title: "Détail d'une facture",
    description: 'Détail complet : missions réalisées, montant total et informations de paiement.',
  },
  {
    id: 'demo-invoice-pdf',
    type: 'page',
    tab: '/tutorial/invoice/preview',
    title: 'Aperçu PDF',
    description: "Visualisez un aperçu de votre facture avant de la signer et de l'envoyer.",
  },
  {
    id: 'demo-invoice-sign',
    type: 'demo',
    demoId: 'invoice-sign',
    title: 'Signature électronique',
    description: 'Signez votre facture en toute sécurité avec un code OTP reçu par SMS. La facture est envoyée automatiquement.',
  },
  {
    id: 'fact-complete',
    type: 'fullscreen',
    title: 'Facturation\nmaîtrisée !',
    description: "Gérez toute votre facturation directement depuis l'application Libheros PRO.",
  },
]

const tutorial = createTutorial(FACTURATION_STEPS, FACTURATION_KEY)

export const useTutorialFacturation = () => tutorial
